import { render, staticRenderFns } from "./PermintaanPembatalanParent.vue?vue&type=template&id=1d6c2188&"
import script from "./PermintaanPembatalanParent.vue?vue&type=script&lang=js&"
export * from "./PermintaanPembatalanParent.vue?vue&type=script&lang=js&"
import style0 from "./PermintaanPembatalanParent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports